import {
    GET_INFO_CALENDAR_STARTED,
    GET_INFO_CALENDAR_SUCCESS,
    GET_INFO_CALENDAR_FAILURE,
    GET_APPOINTMENTS_HOLIDAYS_STARTED,
    GET_APPOINTMENTS_HOLIDAYS_SUCCESS,
    GET_APPOINTMENTS_HOLIDAYS_FAILURE,
    UPDATE_APPOINTMENT_SERVICES_FOR_CALENDAR_STARTED,
    UPDATE_APPOINTMENT_SERVICES_FOR_CALENDAR_SUCCESS,
    UPDATE_APPOINTMENT_SERVICES_FOR_CALENDAR_FAILURE,
    GET_WEEK_APPOINTMENTS_HOLIDAYS_FOR_CALENDAR_STARTED,
    GET_WEEK_APPOINTMENTS_HOLIDAYS_FOR_CALENDAR_SUCCESS,
    GET_WEEK_APPOINTMENTS_HOLIDAYS_FOR_CALENDAR_FAILURE,
    UPDATE_WEEK_APPOINTMENT_SERVICES_FOR_CALENDAR_STARTED,
    UPDATE_WEEK_APPOINTMENT_SERVICES_FOR_CALENDAR_SUCCESS,
    UPDATE_WEEK_APPOINTMENT_SERVICES_FOR_CALENDAR_FAILURE,
    DUPLICATE_APPOINTMENT_FOR_CALENDAR_STARTED,
    DUPLICATE_APPOINTMENT_FOR_CALENDAR_SUCCESS,
    DUPLICATE_APPOINTMENT_FOR_CALENDAR_FAILURE,
    DUPLICATE_SERVICE_FOR_CALENDAR_STARTED,
    DUPLICATE_SERVICE_FOR_CALENDAR_SUCCESS,
    DUPLICATE_SERVICE_FOR_CALENDAR_FAILURE,
    GET_APPOINTMENTS_FOR_DUPLICATE_FOR_CALENDAR_STARTED,
    GET_APPOINTMENTS_FOR_DUPLICATE_FOR_CALENDAR_SUCCESS,
    GET_APPOINTMENTS_FOR_DUPLICATE_FOR_CALENDAR_FAILURE,
} from "../../constants/new-calendar/newCalendar";

const getInfoFromLocalStorage = () => {
    const localInfoData = localStorage.getItem("calendar_info")
    if (localInfoData) {
        const info = JSON.parse(localInfoData)
        return info
    }
    return null
}

const { staffs, staffHours, services, assignStaffSettings } = getInfoFromLocalStorage() || {};

const initialState = {
    staffs: staffs || [],
    services: services || [],
    staffHours: staffHours || [],
    assignStaffSettings: assignStaffSettings || {},
    appointments: [],
    holidays: [],
    loading: false,
    loadingUpdate: false,
    error: null,
    message: null,
    appointmentsForDuplicate: [],
    loadingDuplicate: false,
};

export default function newCalendar(state = initialState, action) {
    switch (action.type) {
        case GET_INFO_CALENDAR_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case GET_INFO_CALENDAR_SUCCESS:
            localStorage.setItem("calendar_info", JSON.stringify(action.payload.data));
            localStorage.setItem("calendar_info_last_update", Date.now());
            return {
                ...state,
                loading: false,
                staffs: action.payload.data.staffs,
                services: action.payload.data.services,
                staffHours: action.payload.data.staffHours,
                assignStaffSettings: action.payload.data.assignStaffSettings,
            };
        case GET_INFO_CALENDAR_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };

        case GET_APPOINTMENTS_HOLIDAYS_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case GET_APPOINTMENTS_HOLIDAYS_SUCCESS:
            return {
                ...state,
                loading: false,
                appointments: action.payload.data.appointments,
                holidays: action.payload.data.holidays,
            };
        case GET_APPOINTMENTS_HOLIDAYS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };

        case UPDATE_APPOINTMENT_SERVICES_FOR_CALENDAR_STARTED:
            return {
                ...state,
                loadingUpdate: true,
                error: null,
                message: null,
            };
        case UPDATE_APPOINTMENT_SERVICES_FOR_CALENDAR_SUCCESS:
            return {
                ...state,
                loadingUpdate: false,
                message: "Appointment has been updated successfully",
            };
        case UPDATE_APPOINTMENT_SERVICES_FOR_CALENDAR_FAILURE:
            return {
                ...state,
                loadingUpdate: false,
                error: action.payload.error,
            };
        case GET_WEEK_APPOINTMENTS_HOLIDAYS_FOR_CALENDAR_STARTED:
            return {
                ...state,
                loading: true,
                error: null,
                message: null,
            };
        case GET_WEEK_APPOINTMENTS_HOLIDAYS_FOR_CALENDAR_SUCCESS:
            return {
                ...state,
                loading: false,
                appointments: action.payload.data.appointments,
                holidays: action.payload.data.holidays,
            };
        case GET_WEEK_APPOINTMENTS_HOLIDAYS_FOR_CALENDAR_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        case UPDATE_WEEK_APPOINTMENT_SERVICES_FOR_CALENDAR_STARTED:
            return {
                ...state,
                loadingUpdate: true,
                error: null,
                message: null,
            };
        case UPDATE_WEEK_APPOINTMENT_SERVICES_FOR_CALENDAR_SUCCESS:
            return {
                ...state,
                loadingUpdate: false,
                message: "Appointments have been updated successfully",
            };
        case UPDATE_WEEK_APPOINTMENT_SERVICES_FOR_CALENDAR_FAILURE:
            return {
                ...state,
                loadingUpdate: false,
                error: action.payload.error,
            };
        case GET_APPOINTMENTS_FOR_DUPLICATE_FOR_CALENDAR_STARTED:
            return {
                ...state,
                appointmentsForDuplicate: [],
                loadingDuplicate: true,
            };
        case GET_APPOINTMENTS_FOR_DUPLICATE_FOR_CALENDAR_SUCCESS:
            return {
                ...state,
                loadingDuplicate: false,
                appointmentsForDuplicate: action.payload.data.appointments,
            };
        case GET_APPOINTMENTS_FOR_DUPLICATE_FOR_CALENDAR_FAILURE:
            return {
                ...state,
                loadingDuplicate: false,
                error: action.payload.error,
            };

        case DUPLICATE_APPOINTMENT_FOR_CALENDAR_STARTED:
            return {
                ...state,
                loadingDuplicate: true,
                error: null,
                message: null,
            };
        case DUPLICATE_APPOINTMENT_FOR_CALENDAR_SUCCESS:
            return {
                ...state,
                loadingDuplicate: false,
                message: "Appointment has been duplicated successfully",
            };
        case DUPLICATE_APPOINTMENT_FOR_CALENDAR_FAILURE:
            return {
                ...state,
                loadingDuplicate: false,
                error: action.payload.error,
            };

        case DUPLICATE_SERVICE_FOR_CALENDAR_STARTED:
            return {
                ...state,
                loadingDuplicate: true,
                error: null,
                message: null,
            };
        case DUPLICATE_SERVICE_FOR_CALENDAR_SUCCESS:
            return {
                ...state,
                loadingDuplicate: false,
                message: "Service has been duplicated successfully",
            };
        case DUPLICATE_SERVICE_FOR_CALENDAR_FAILURE:
            return {
                ...state,
                loadingDuplicate: false,
                error: action.payload.error,
            };

        default:
            return {
                ...state,
            };
    }
}
